import { mapState } from 'vuex';
import card from "@/components/assets/user/card/index.vue";
import f from '@/application/shared/functions.js';

export default {
    name: 'topmenu',
    props: {
    },

    components : {
        card
    },

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
		userinfo : state => state.userinfo,

        path : function(){
            return this.$router.currentRoute.name
        },
        mobileview : state => state.mobileview,
        update : state => state.update,
        updating : state => state.updating,
        playingstory : state => state.playingstory,
        isAndroid : function(){
            return f.isAndroid()
        },

        showback : function(){
            console.log('this.$route', this.$route)
			return this.$route.name == 'course' || this.$route.name == 'podcast' || this.$route.name == 'story' || this.$route.name == 'joined' || (this.$route.name == 'chat' && this.$route.fullPath != '/chat')
        },

        successCDVpayment : state => state.successCDVpayment
    }),

    methods : {
        gotohome : function(){
            this.$router.push('/')
        },

        openLeftMenu : function(){
            this.$store.commit("leftmenuOpened", true);
        },

        installUpdates : function(){

            this.$dialog.confirm(
				this.$t('labels.installUpdateQuestion'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {


				this.core.cordovakit.autoupdater.downloadAndInstall(this.update).catch(e => {
                    this.$dialog.alert(
                        e, {
                        okText: this.$t('app.okay')
                    }).catch(e => {

                    })
                })
			}).catch( e => {

                

        
			})

            
        }
    },
}